const compareConstants = {
  GET_COMPARE_LIST_REQUEST: 'GET_COMPARE_LIST_REQUEST',
  GET_COMPARE_LIST_SUCCESS: 'GET_COMPARE_LIST_SUCCESS',
  GET_COMPARE_LIST_FAILURE: 'GET_COMPARE_LIST_FAILURE',
  SET_COMPARE_TRADE_OFFER:  'SET_COMPARE_TRADE_OFFER',
};

export default compareConstants;